import config from 'config';

const { GTAG } = config;

export function gTagEvent(eventName = '', params = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
}

export function gTagTrackPageView(location = {}) {
  if (window.gtag) {
    const pathname = `${location.pathname}${location.search}`;
    window.gtag('config', GTAG.id, { page_path: pathname });
  }
}
export default {
  gTagEvent
};



// WEBPACK FOOTER //
// ./src/libs/gTag.js